'use strict';

var _jsx = require('@babel/runtime/helpers/jsx');
var React = require('react');
require('prop-types');
var classnames = require('classnames');
function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
  if (typeof f == "function") {
    var a = function a() {
      if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
      }
      return f.apply(this, arguments);
    };
    a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {
    value: true
  });
  Object.keys(n).forEach(function (k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function () {
        return n[k];
      }
    });
  });
  return a;
}
const RECOMMENDATIONS_HEART_EMPTY = 'recommendations-heart-empty';
const RECOMMENDATIONS_HEART_FULL = 'recommendations-heart-full';
const RECOMMENDATIONS_FULL_ICON = 'recommendations-full_icon';
const RECOMMENDATIONS_CHEVRON = 'recommendations-chevron';
const RECOMMENDATIONS_START_EMPTY = 'recommendations-star-empty';
const RECOMMENDATIONS_START_HALF = 'recommendations-star-half';
const RECOMMENDATIONS_START_FULL = 'recommendations-star-full';
const RECOMMENDATIONS_MELI_LOGO = 'recommendations-meli_logo';
const RECOMMENDATIONS_MELI_COINS = 'recommendations-meli_coins';
const RECOMMENDATIONS_CPG_ICON = 'recommendations-cpg_icon';
const RECOMMENDATIONS_CBT_ICON = 'recommendations-cbt_icon';
const RECOMMENDATIONS_BLACK_FRIDAY_ICON = 'recommendations-black-friday_icon';
const RECOMMENDATIONS_MELICHOICE_LOGO = 'recommendations-melichoice_logo';
const RECOMMENDATIONS_BUFLO_ICON_INFO = 'recommendations-buflo_icon_info';
const RECOMMENDATIONS_MSHOPS_LOGO = 'recommendations-mshops_logo';
const RECOMMENDATIONS_CLOCK_ICON = 'recommendations-clock_icon';
const RECOMMENDATIONS_STORE_ICON = 'recommendations-store_icon';
const RECOMMENDATIONS_FIRE_ICON = 'recommendations-fire_icon';
const RECOMMENDATIONS_BADGE_ICON = 'recommendations-badge_icon';
const RECOMMENDATIONS_INFO_ICON = 'recommendations-info_icon';
const RECOMMENDATIONS_APPAREL_ICON = 'recommendations-clothing_icon';
const RECOMMENDATIONS_BEAUTY_ICON = 'recommendations-beauty_icon';
const RECOMMENDATIONS_TOOLS_ICON = 'recommendations-tools_icon';
const RECOMMENDATIONS_SUPERMARKET_ICON = 'recommendations-super_icon';
const RECOMMENDATIONS_DECO_ICON = 'recommendations-furniture_icon';
var icons = /*#__PURE__*/Object.freeze({
  __proto__: null,
  RECOMMENDATIONS_APPAREL_ICON: RECOMMENDATIONS_APPAREL_ICON,
  RECOMMENDATIONS_BADGE_ICON: RECOMMENDATIONS_BADGE_ICON,
  RECOMMENDATIONS_BEAUTY_ICON: RECOMMENDATIONS_BEAUTY_ICON,
  RECOMMENDATIONS_BLACK_FRIDAY_ICON: RECOMMENDATIONS_BLACK_FRIDAY_ICON,
  RECOMMENDATIONS_BUFLO_ICON_INFO: RECOMMENDATIONS_BUFLO_ICON_INFO,
  RECOMMENDATIONS_CBT_ICON: RECOMMENDATIONS_CBT_ICON,
  RECOMMENDATIONS_CHEVRON: RECOMMENDATIONS_CHEVRON,
  RECOMMENDATIONS_CLOCK_ICON: RECOMMENDATIONS_CLOCK_ICON,
  RECOMMENDATIONS_CPG_ICON: RECOMMENDATIONS_CPG_ICON,
  RECOMMENDATIONS_DECO_ICON: RECOMMENDATIONS_DECO_ICON,
  RECOMMENDATIONS_FIRE_ICON: RECOMMENDATIONS_FIRE_ICON,
  RECOMMENDATIONS_FULL_ICON: RECOMMENDATIONS_FULL_ICON,
  RECOMMENDATIONS_HEART_EMPTY: RECOMMENDATIONS_HEART_EMPTY,
  RECOMMENDATIONS_HEART_FULL: RECOMMENDATIONS_HEART_FULL,
  RECOMMENDATIONS_INFO_ICON: RECOMMENDATIONS_INFO_ICON,
  RECOMMENDATIONS_MELICHOICE_LOGO: RECOMMENDATIONS_MELICHOICE_LOGO,
  RECOMMENDATIONS_MELI_COINS: RECOMMENDATIONS_MELI_COINS,
  RECOMMENDATIONS_MELI_LOGO: RECOMMENDATIONS_MELI_LOGO,
  RECOMMENDATIONS_MSHOPS_LOGO: RECOMMENDATIONS_MSHOPS_LOGO,
  RECOMMENDATIONS_START_EMPTY: RECOMMENDATIONS_START_EMPTY,
  RECOMMENDATIONS_START_FULL: RECOMMENDATIONS_START_FULL,
  RECOMMENDATIONS_START_HALF: RECOMMENDATIONS_START_HALF,
  RECOMMENDATIONS_STORE_ICON: RECOMMENDATIONS_STORE_ICON,
  RECOMMENDATIONS_SUPERMARKET_ICON: RECOMMENDATIONS_SUPERMARKET_ICON,
  RECOMMENDATIONS_TOOLS_ICON: RECOMMENDATIONS_TOOLS_ICON
});
var require$$0 = /*@__PURE__*/getAugmentedNamespace(icons);
var constants = require$$0;
var _g, _rect, _defs;
const namespace = 'ui-recommendations-icon';

/* eslint-disable max-len */
const DecoIcon = _ref => {
  let {
    className = null
  } = _ref;
  return /*#__PURE__*/_jsx("svg", {
    className: classnames(namespace, className),
    xmlns: "http://www.w3.org/2000/svg",
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none"
  }, void 0, _g || (_g = /*#__PURE__*/_jsx("g", {
    clipPath: "url(#clip0_4_5615)"
  }, void 0, /*#__PURE__*/_jsx("rect", {
    width: "40",
    height: "40",
    rx: "20",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    d: "M32.3204 18.0048V15.4219H30.3441C29.7068 13.8894 28.6287 12.5806 27.2465 11.6617C25.8644 10.7427 24.2404 10.2549 22.5806 10.2602H21.9984V7.67543H18.0026V10.2583H17.4203C15.7605 10.253 14.1366 10.7408 12.7544 11.6597C11.3723 12.5787 10.2941 13.8875 9.65682 15.42H7.67955V19.4177H8.96878V27.8998C8.97006 29.0726 9.43638 30.197 10.2655 31.0265C11.0946 31.8559 12.2188 32.3228 13.3915 32.3246H26.6084C27.7809 32.3228 28.9048 31.8562 29.7338 31.0272C30.5629 30.1981 31.0294 29.0742 31.0312 27.9018C31.0312 27.9018 31.0312 25.8369 31.0312 24.5358C31.0312 23.2347 31.0312 21.4673 31.0312 21.4673V19.4177H31.3988H32.3204V18.0048ZM19.4136 9.08887H20.5864V10.2602H19.4141L19.4136 9.08887ZM17.4189 11.6717H22.5806C23.8601 11.6675 25.1162 12.0151 26.2115 12.6765C27.3069 13.3379 28.1993 14.2877 28.7914 15.4219H11.2129C11.8041 14.2879 12.6958 13.3382 13.7904 12.6768C14.885 12.0154 16.1399 11.6677 17.4189 11.6717ZM9.09105 16.8335H30.9089V18.0048H9.09105V16.8335ZM29.6197 27.8998C29.6182 28.698 29.3004 29.463 28.736 30.0274C28.1716 30.5918 27.4066 30.9096 26.6084 30.9111H13.3915C12.5934 30.9096 11.8283 30.5918 11.264 30.0274C10.6996 29.463 10.3818 28.698 10.3803 27.8998V19.4177H29.6197V27.8998Z",
    fill: "#3483FA"
  }))), _rect || (_rect = /*#__PURE__*/_jsx("rect", {
    x: "0.5",
    y: "0.5",
    width: "39",
    height: "39",
    rx: "19.5",
    stroke: "black",
    strokeOpacity: "0.07"
  })), _defs || (_defs = /*#__PURE__*/_jsx("defs", {}, void 0, /*#__PURE__*/_jsx("clipPath", {
    id: "clip0_4_5615"
  }, void 0, /*#__PURE__*/_jsx("rect", {
    width: "40",
    height: "40",
    rx: "20",
    fill: "white"
  })))));
};
const DecoIconconMemo = /*#__PURE__*/React.memo(DecoIcon);
DecoIconconMemo.ICON_ID = constants.RECOMMENDATIONS_DECO_ICON;
var DecoIconconMemo$1 = DecoIconconMemo;
module.exports = DecoIconconMemo$1;
